<template>
<div>
    <div class="breadcrumb__block about__breadcrumbs">
        <router-link to="/" >
          <p v-text="$store.getters.pages._.meta_title" /> 
        </router-link />  
          <p class="breadcrumb__title" v-text="page.title" />
       
    </div>  
  <div class="main__about about container">
    <h1 v-text="parentPage.title" />
    <div class="about__triggers">
      <div class="about__trigger trigger" @click="subNavOpen=true"
        v-text="page.nav_title" />
    </div>
    <nav class="about__nav">
      <ul class="about__nav-list">
        <router-link v-if="item['show_'+lang]===1" v-for="(item, i) in parentPage.subpages"
          :key="'sub'+i" class="about__nav-item" tag="li" :to="'/'+parentPage.slug+'/'+item.slug">
          <a class="about__nav-link" v-text="item.nav_title"></a>
        </router-link>
      </ul>
    </nav>
    <router-view class="about__router" />
    <div class="about__dropdown dropdown" ref="dropdown" v-show="subNavOpen">
      <div class="dropdown__top">
        <i class="dropdown__close" @click="subNavOpen=false" />
      </div>
      <div class="dropdown__dialog">
        <ul class="dropdown__list">
          <router-link class="dropdown__item" tag="li" :to="'/'+parentPage.slug+'/'+item.slug"
            v-for="(item, i) in parentPage.subpages" :key="'item'+i"
            v-if="item.path!==$route.path && item['show_'+lang]===1"
            @click.native="subNavOpen=false">
            <i class="dropdown__check" />
            <a class="dropdown__text" v-text="item.nav_title" />
          </router-link>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '@/mixins/page'

export default {
  mixins: [page],
  name: 'PageWithSubpages',
  components: {},
  computed: {
    ...mapGetters(['ui', 'device', 'lang']),
    parentPage() {
      return this.page.subpages ? this.page : this.page.parent
    }
  },
  data() {
    return {
      subNavOpen: false
    }
  },
  methods: {},

  watch: {
    subNavOpen(newVal, oldVal) {
      if (newVal && this.device.winW < 769) {
        this.$nextTick(() => {
          var $page = document.querySelector('[data-page]')
          this.$refs['dropdown'].style.top = $page.scrollTop + 'px'
          $page.style.zIndex = 5
          this.$store.dispatch('scrollFix')
        })
      } else {
        this.$store.dispatch('scrollUnFix')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/PageWithSubpages.vue